import './App.css';
import React from 'react';
import Contact from './Pages/Contact'
import { BrowserRouter, Route, Routes } from 'react-router-dom';

function App() {

  return (
    <BrowserRouter>
        <Routes>
          <Route path={"/form/contact/"} element={<Contact/>}/>    
        </Routes>
    </BrowserRouter>
  );
}

export default App;
